import { AppLocaleMessageObject, LocaleOptions } from "@/plugins/i18n/types";

const BaseMessages: AppLocaleMessageObject = {
  home: {
    welcome: "Dobrodošli",
    liveChannelsHeading: "Kanali uživo",
    watchNow: "Gledaj sada"
  },
  sidebar: {
    home: "Početna",
    channels: "Kanali",
    buffet: "Buffet / EPG",
    settings: "Podešavanja",
    vod: "VoD Biblioteka"
  },
  buffet: {
    datesFilter: {
      today: "Danas",
      yesterday: "Juce",
      tomorrow: "Sutra"
    },
    epgCard: {
      play: "Pusti",
      epg: "EPG",
      info: "Info"
    }
  },
  channelsPage: {
    nowOnTV: "Sada na TV",
    channels: "Kanali",
    infoPage: {
      play: "Pusti"
    },
    epgCard: {
      play: "Pusti",
      epg: "EPG",
      info: "Info"
    },
    channelCard: {
      play: "Pusti",
      epg: "EPG",
      add: "Dodaj"
    }
  },
  categoriesEnum: {
    allChannels: "Svi kanali",
    favorites: "Favoriti"
  },
  buffetCategoriesEnum: {
    home: "Početna"
  },
  vodPage: {
    types: {
      movies: "Filmovi",
      tvShows: "Serije"
    },
    vodCard: {
      play: "Pusti",
      info: "Info",
      add: "Dodaj"
    }
  },
  settings: {
    title: "Pregledaj Svoja",
    subTitle: "Podešavanja",
    profileSectionTitle: "Profil:",
    personalSectionTitle: "Personalno:",
    otherSectionTitle: "Drugo:",
    cardsPersonal: {
      logout: "Odjava",
      restart: "Restart",
      language: {
        heading: "Odabir",
        subHeading: "Jezika"
      },
      pin: {
        heading: "Promena",
        subHeading: "Pina"
      }
    },
    cardsOther: {
      sortAndLock: {
        heading: "Sortiranje i zaključavanje",
        subHeading: "Kanala"
      },
      support: {
        heading: "Podrška, O aplikaciji",
        subHeading: "Generalne informacije",
        headingRightSideMenu: "Podrška"
      }
    },
    cardsProfile: {
      btnEdit: "Izmeni",
      btnDelete: "Ukloni",
      user: {
        profile: "Profil",
        child: "Pod"
      },
      addNew: {
        addChild: "Dodaj Pod",
        createNew: "Kreiraj nov"
      }
    },
    rightSideMenu: {
      logoutBtn: "Odjava",
      restartBtn: "Restart",
      oldPinInput: "Unesite Stari PIN*",
      newPinInput: "Unesite Novi PIN*",
      confirmNewPinInput: "Ponovo unesite novi PIN",
      confirmPinBtn: "Potvrdi",
      contactUs: "Kontaktirajte nas putem:"
    },
    confirmModal: {
      userDelete: "Da li ste sigurni da želite da izbrišete korisnika?",
      backToSettings:
        "Da li ste sigurni da želite da se vratite na Podešavanja?",
      yes: "Da",
      no: "Ne"
    },
    pinModal: {
      confirmPinText: "Unesite PIN kod",
      pinInput: "Vaš PIN ovde",
      confirmBtn: "Potvrdi"
    },
    editUserForm: {
      username: "* Korisničko ime / Ime profila:",
      name: "* Ime",
      lastName: "* Prezime",
      email: "* Email",
      phone: "* Telefon",
      oldPass: "* Stara Lozinka",
      password: "* Lozinka",
      confirmPass: "* Potvrdi Lozinku",
      oldPin: "* Unesite stari PIN",
      pin: "* Pin kod",
      confirmPin: "* Potvrdite PIN",
      saveBtn: "Sačuvaj",
      title: "Izmeni korisnika",
      subTitle: "Profil"
    },
    sortAndLock: {
      title: "Sortiraj i zaključaj",
      subTitle: "Kanali",
      cardLock: "Zaključaj",
      cardUnlock: "Otključaj",
      cardSort: "Sortiranje",
      cardAdd: "Dodaj",
      cardRemove: "Ukloni"
    }
  },
  overlay: {
    backBtn: "Nazad",
    contentNext: {
      later: "Sledi",
      upNext: "Sledi",
      nextEpisodeBtn: "Sledeća epizoda"
    }
  }
};

const RS: LocaleOptions = {
  BaseMessages
};

export default RS;
